module.exports = __webpack_public_path__ + "img/AirCompModule.9d6fadfe.gif";